var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from 'styled-components';
import { black } from '../../colors';
import { ReactComponent as LanguageSwitcherIcon } from '../../static-icons/globe.svg';
import { widgetItemCss } from '../Header.styles';
export var StyledLanguageSwitcherIcon = styled(LanguageSwitcherIcon).withConfig({
  displayName: "LanguageSwitcherstyles__StyledLanguageSwitcherIcon",
  componentId: "inklef-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 2.4rem;\n  margin-right: 0.8rem;\n"], ["\n  width: 2.4rem;\n  margin-right: 0.8rem;\n"])));
export var MobileLanguageSwitcherLink = styled.a.withConfig({
  displayName: "LanguageSwitcherstyles__MobileLanguageSwitcherLink",
  componentId: "inklef-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  padding-right: 3.4rem;\n"], ["\n  ", "\n  color: ", ";\n  padding-right: 3.4rem;\n"])), widgetItemCss, function (pr) {
  return pr.color ? pr.color : black();
});
var templateObject_1, templateObject_2;